/**
 * Gender Toggle + Menu State Persistence
 * Manages men/women toggle on homepage, syncs menu tabs, and persists menu dropdown states
 */
(function() {
  'use strict';

  var GENDER_STORAGE_KEY = 'fflirtygo-selected-gender';
  var MENU_STATE_KEY = 'flirtygo-menu-state';
  var MENU_STATE_EXPIRY = 30 * 60 * 1000; // 30 minutes

  /* ============================================
     GENDER STATE HELPERS
  ============================================ */

  function getGenderFromURL() {
    try {
      var params = new URLSearchParams(window.location.search);
      var g = params.get('gender');
      if (g === 'men' || g === 'women') return g;
    } catch (e) {}
    return null;
  }

  function readStoredGender() {
    var urlGender = getGenderFromURL();
    if (urlGender) return urlGender;

    try {
      var storedGender = sessionStorage.getItem(GENDER_STORAGE_KEY);
      if (storedGender === 'men' || storedGender === 'women') return storedGender;
    } catch (e) {}

    return null;
  }

  function persistGender(gender) {
    try {
      sessionStorage.setItem(GENDER_STORAGE_KEY, gender);
    } catch (e) {}
  }

  /* ============================================
     MENU STATE PERSISTENCE
  ============================================ */

  function saveMenuState() {
    var state = {
      openMenus: [],
      activeTab: null,
      timestamp: Date.now()
    };

    var activeTabButton = document.querySelector('.nav-top-tabs__btn.is-active');
    if (activeTabButton) {
      state.activeTab = activeTabButton.getAttribute('data-tab');
    }

    document.querySelectorAll('menu-item.is-open').forEach(function(menuItem) {
      var link = menuItem.querySelector('a');
      if (link) {
        var menuText = link.textContent.trim();
        var parentLi = menuItem.closest('li');
        var parentTitle = parentLi ? parentLi.getAttribute('data-title') : null;
        state.openMenus.push({ text: menuText, parentTitle: parentTitle });
      }
    });

    try {
      sessionStorage.setItem(MENU_STATE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function restoreDropdowns(openMenus) {
    if (!openMenus || openMenus.length === 0) return;

    openMenus.forEach(function(menuState) {
      var menuItems;
      if (menuState.parentTitle) {
        var parentLi = document.querySelector('li[data-title="' + menuState.parentTitle + '"]');
        if (parentLi) {
          menuItems = parentLi.querySelectorAll('menu-item');
        }
      } else {
        menuItems = document.querySelectorAll('menu-item');
      }

      if (menuItems) {
        menuItems.forEach(function(menuItem) {
          var link = menuItem.querySelector('a');
          if (link && link.textContent.trim() === menuState.text) {
            menuItem.classList.add('is-open');
            var parentMenuItem = menuItem.closest('li');
            if (parentMenuItem) {
              var parentUl = parentMenuItem.closest('ul');
              if (parentUl && parentUl.previousElementSibling && parentUl.previousElementSibling.tagName === 'MENU-ITEM') {
                parentUl.previousElementSibling.classList.add('is-open');
              }
            }
          }
        });
      }
    });
  }

  function restoreMenuState() {
    try {
      var savedState = sessionStorage.getItem(MENU_STATE_KEY);
      var state = null;

      if (savedState) {
        state = JSON.parse(savedState);
        if (Date.now() - state.timestamp > MENU_STATE_EXPIRY) {
          sessionStorage.removeItem(MENU_STATE_KEY);
          state = null;
        }
      }

      if (!state || !state.activeTab) {
        var gender = readStoredGender();
        if (gender) {
          state = state || { openMenus: [], timestamp: Date.now() };
          state.activeTab = gender;
        }
      }

      if (!state) return;

      if (state.activeTab) {
        var tabButton = document.querySelector('.nav-top-tabs__btn[data-tab="' + state.activeTab + '"]');
        if (tabButton && !tabButton.classList.contains('is-active')) {
          tabButton.click();
          setTimeout(function() { restoreDropdowns(state.openMenus); }, 250);
        } else {
          restoreDropdowns(state.openMenus);
        }
      } else {
        restoreDropdowns(state.openMenus);
      }
    } catch (e) {}
  }

  function syncMenuTab(gender) {
    try {
      var existing = sessionStorage.getItem(MENU_STATE_KEY);
      var state = existing ? JSON.parse(existing) : { openMenus: [], timestamp: Date.now() };
      state.activeTab = gender;
      state.timestamp = Date.now();
      sessionStorage.setItem(MENU_STATE_KEY, JSON.stringify(state));
    } catch (e) {}

    var tabBtn = document.querySelector('.nav-top-tabs__btn[data-tab="' + gender + '"]');
    if (tabBtn && !tabBtn.classList.contains('is-active') && tabBtn.offsetParent !== null) {
      tabBtn.click();
    }
  }

  /* ============================================
     MENU EVENT HANDLERS
  ============================================ */

  function attachMenuSaveHandlers() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('menu-item a');
      if (link && link.getAttribute('href') && link.getAttribute('href') !== '#') {
        saveMenuState();
      }
    });

    document.querySelectorAll('.nav-top-tabs__btn').forEach(function(tab) {
      tab.addEventListener('click', function() {
        setTimeout(saveMenuState, 100);
      });
    });
  }

  function attachMenuOpenListener() {
    document.addEventListener('click', function(e) {
      var navToggle = e.target.closest('[data-action="toggle-nav"]');
      if (navToggle) {
        var attempts = 0;
        var maxAttempts = 10;

        var tryRestore = function() {
          attempts++;
          var tabButtons = document.querySelectorAll('.nav-top-tabs__btn');
          if (tabButtons.length > 0 && tabButtons[0].offsetParent !== null) {
            restoreMenuState();
          } else if (attempts < maxAttempts) {
            setTimeout(tryRestore, 50);
          }
        };
        setTimeout(tryRestore, 100);
      }
    });
  }

  /* ============================================
     HOMEPAGE GENDER TOGGLE
  ============================================ */

  function initGenderToggle() {
    var toggle = document.getElementById('gender-toggle');
    if (!toggle) return;

    var menToggleLabel = document.querySelector('.toggle-men-item');
    var womenToggleLabel = document.querySelector('.toggle-women-item');

    function getGenderFromToggle() {
      return toggle.checked ? 'women' : 'men';
    }

    function setToggleUI(gender) {
      var isWomen = gender === 'women';
      toggle.checked = isWomen;
      if (menToggleLabel) menToggleLabel.classList.toggle('selected', !isWomen);
      if (womenToggleLabel) womenToggleLabel.classList.toggle('selected', isWomen);
    }

    /* Hero image switcher */
    var heroImg = document.querySelector('.combo-hero-image');

    function updateHero() {
      if (!heroImg) return;
      var gender = toggle.checked ? 'women' : 'men';
      var isMobile = window.innerWidth <= 600;
      var src = isMobile
        ? heroImg.dataset[gender + 'Mobile']
        : heroImg.dataset[gender + 'Desktop'];
      if (src) heroImg.src = src;
      var srcset = heroImg.dataset[gender + 'Srcset'];
      if (srcset) heroImg.srcset = srcset;
    }

    /* Category cards */
    var categoryCards = document.querySelectorAll('.category-card');

    function updateCategories() {
      var gender = toggle.checked ? 'women' : 'men';
      categoryCards.forEach(function(card) {
        card.style.display = card.dataset.gender === gender ? 'block' : 'none';
      });
    }

    /* Men/Women swipers */
    var menSwiperEl = document.querySelector('.men-swiper');
    var womenSwiperEl = document.querySelector('.women-swiper');

    var menSwiper = new Swiper('.men-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 15,
      pagination: { el: '.men-swiper .swiper-pagination', clickable: true }
    });

    var womenSwiper = new Swiper('.women-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 15,
      pagination: { el: '.women-swiper .swiper-pagination', clickable: true }
    });

    function updateSwipers() {
      if (toggle.checked) {
        menSwiperEl.classList.remove('active');
        womenSwiperEl.classList.add('active');
      } else {
        womenSwiperEl.classList.remove('active');
        menSwiperEl.classList.add('active');
      }
    }

    /* Combo cards */
    var comboCards = document.querySelectorAll('.combo-card');
    var comboSliderWrappers = document.querySelectorAll('.combo-slider-wrapper');

    function showComboCards(gender) {
      if (comboSliderWrappers.length > 0) {
        comboSliderWrappers.forEach(function(wrapper) {
          if (wrapper.dataset.gender === gender) {
            wrapper.classList.add('active');
          } else {
            wrapper.classList.remove('active');
          }
        });
        return;
      }

      comboCards.forEach(function(card) { card.style.display = 'none'; });
      var filtered = Array.prototype.filter.call(comboCards, function(card) {
        return card.dataset.gender === gender;
      });
      filtered.forEach(function(card, i) {
        if (window.innerWidth >= 1001 && i < 4) {
          card.style.display = 'flex';
        } else if (window.innerWidth < 1001 && i < 2) {
          card.style.display = 'flex';
        }
      });
    }

    /* Discover style swiper */
    var discoverStyleSwiper = new Swiper('.discover-style-swiper', {
      slidesPerView: 1,
      loop: false,
      pagination: { el: '.discover-style-swiper .swiper-pagination', clickable: true }
    });

    function updateDiscoverSwiper() {
      var gender = toggle.checked ? 'women' : 'men';
      document.querySelectorAll('.discover-style-swiper .swiper-slide').forEach(function(slide) {
        slide.style.display = slide.classList.contains('gender-' + gender) ? 'block' : 'none';
      });
      discoverStyleSwiper.update();
      discoverStyleSwiper.slideTo(0);
    }

    /* Sync all UI for a given gender */
    function syncGenderState(gender, options) {
      options = options || {};
      var shouldPersist = options.persist || false;
      var emitEvent = options.emitEvent || false;

      setToggleUI(gender);
      updateHero();
      updateCategories();
      updateSwipers();
      showComboCards(gender);
      updateDiscoverSwiper();
      syncMenuTab(gender);

      if (shouldPersist) persistGender(gender);

      if (emitEvent) {
        document.dispatchEvent(new CustomEvent('genderChanged', { detail: { gender: gender } }));
      }
    }

    /* Initial load */
    var initialGender = readStoredGender() || getGenderFromToggle();
    syncGenderState(initialGender, { persist: true, emitEvent: true });

    /* Toggle change listener */
    toggle.addEventListener('change', function() {
      syncGenderState(getGenderFromToggle(), { persist: true, emitEvent: true });
    });

    /* Back/forward navigation */
    window.addEventListener('pageshow', function() {
      var restoredGender = readStoredGender() || 'men';
      setTimeout(function() {
        setToggleUI(restoredGender);
        syncGenderState(restoredGender, { persist: false, emitEvent: true });
      }, 50);
    });

    /* Resize listener */
    window.addEventListener('resize', function() {
      updateHero();
      showComboCards(toggle.checked ? 'women' : 'men');
    });
  }

  /* ============================================
     GENDER SYNC LISTENER (for pages without toggle)
  ============================================ */

  function attachGenderSyncListener() {
    document.addEventListener('genderChanged', function(e) {
      if (e && e.detail && e.detail.gender) {
        var gender = e.detail.gender;
        var tabButton = document.querySelector('.nav-top-tabs__btn[data-tab="' + gender + '"]');
        if (tabButton && !tabButton.classList.contains('is-active') && tabButton.offsetParent !== null) {
          tabButton.click();
        }
      }
    });
  }

  /* ============================================
     INIT
  ============================================ */

  document.addEventListener('DOMContentLoaded', function() {
    initGenderToggle();
    attachMenuSaveHandlers();
    attachMenuOpenListener();
    attachGenderSyncListener();
  });
})();
